export default __webpack_public_path__ + "static/media/en.233c487d.svg";